<template>
    <el-container class="mainJjglxxBody">
        <el-col class="box">
            <el-card class="box-card" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="headOne">{{JjjgxxList.DWQCH}}</div>
                    <div class="headSecond">{{JjjgxxList.BGDZ}}</div>
                </div>
                <el-row>
                <span class="xxContent1">
                    备案编号：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.ZZZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    统一社会信用代码：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.ZJHM}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                   法定代表人/负责人：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.FRDB}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    机构类型：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.QYLX}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    经营范围：
                </span>
                    <span class="xxContent2">
                     {{JjjgxxList.JYFW}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    经营场所：
                </span>
                    <span class="xxContent2">
                     {{JjjgxxList.BGDZ}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    从业人数：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.CYRY}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    高级房地产经纪人数：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.SENIORREALESTATEAGENT}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    房地产经纪人数：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.REALESTATEAGENT}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    房地产经纪协理人数：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.ASSOCIATEREALESTATEBROKER}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                   是否代理销售商品房楼盘：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.ISCANSALE}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    备案有效期：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAYXQ}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    年审状态：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.AUDITINFO}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    监管机构：
                </span>
                    <span class="xxContent2">
                     {{JjjgxxList.GLJG}}
                </span>
                </el-row>

            </el-card>
            <el-row class="buttonRow">
                <el-button type="primary" @click="onSubmit">查看门店</el-button>
                <el-button type="primary" @click="resetHt(JjjgxxList.DWXH)">查看从业人员</el-button>
                <el-button type="primary" @click="openHT">查看备案证书</el-button>
            </el-row>
        </el-col>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "jjjggs_cx",
        data() {
            return {
                JjjgxxList:{
                    JGMC:'汉中鸿润置业有限公司',
                    GSDZ:'汉中市汉台区汉中颐高互联网双创园',
                    BAZH:'某某',
                },
            }
        },
        methods:{
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            handleUserList(){
                this.HtxxSelect({_module:'TT',_method:'Jjgl_dwcxByid',id:this.$route.query.id,}).then((res) => {  //这是从本地请求的数据接口，
                    this.JjjgxxList = res._result;
                })
            },
            ...mapActions([
                'HtxxSelect','Ymxxinit',
            ]),
            onSubmit(){
                this.warnMessage("功能正完善中...");
            },
            resetHt(id){
                this.warnMessage("功能正完善中...");
                //this.$router.push({path:'/ywhome/jjgl/qycyrygs_cx',query:{id:id}})
            },
            openHT() {
                console.log(this.JjjgxxList.ZZZH);
                const htUrl = 'http://127.0.0.1:8791/api/downloadDocument?ywbh=' + this.JjjgxxList.ZZZH;
                window.open(htUrl, '_blank');
            },
        },
        created() {
            this.handleUserList()
        }
    }
</script>

<style scoped>
    @import "../../assets/css/jjgl/jjglxx_main.css";
</style>